'use strict';

var Rx = require('rx');

var oldpopstate = window.onpopstate;

var popstate = new Rx.Subject();
var navigate = new Rx.Subject();

// window.onpopstate = function(ev) {
//   popstate.onNext(ev.state);
//   if (oldpopstate) {
//     oldpopstate(ev);
//   }
// };

// navigate
// .filter(function(page) {
//   return !window.history.state || window.history.state.page !== page;
// })
// .subscribe(function(page){
//   window.history.pushState({page: page}, 'Discovery', '');
// });

module.exports = {
  navigate: navigate,
  popstate: popstate
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9vcHQvZGF0YS9qZW5raW5zL2pvYnMvZGlzY292ZXJ5X2J1aWxkL3dvcmtzcGFjZS9kaXNjb3ZlcnkvZGlzY292ZXJ5L3NyYy9qcy9yb3V0ZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsWUFBWSxDQUFDOztBQUViLElBQUksRUFBRSxHQUFHLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQzs7QUFFdkIsSUFBSSxXQUFXLEdBQUcsTUFBTSxDQUFDLFVBQVUsQ0FBQzs7QUFFcEMsSUFBSSxRQUFRLEdBQUcsSUFBSSxFQUFFLENBQUMsT0FBTyxFQUFFLENBQUM7QUFDaEMsSUFBSSxRQUFRLEdBQUcsSUFBSSxFQUFFLENBQUMsT0FBTyxFQUFFLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBaUJoQyxNQUFNLENBQUMsT0FBTyxHQUFHO0FBQ2YsVUFBUSxFQUFFLFFBQVE7QUFDbEIsVUFBUSxFQUFFLFFBQVE7Q0FDbkIsQ0FBQyIsImZpbGUiOiIvb3B0L2RhdGEvamVua2lucy9qb2JzL2Rpc2NvdmVyeV9idWlsZC93b3Jrc3BhY2UvZGlzY292ZXJ5L2Rpc2NvdmVyeS9zcmMvanMvcm91dGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiJ3VzZSBzdHJpY3QnO1xuXG52YXIgUnggPSByZXF1aXJlKCdyeCcpO1xuXG52YXIgb2xkcG9wc3RhdGUgPSB3aW5kb3cub25wb3BzdGF0ZTtcblxudmFyIHBvcHN0YXRlID0gbmV3IFJ4LlN1YmplY3QoKTtcbnZhciBuYXZpZ2F0ZSA9IG5ldyBSeC5TdWJqZWN0KCk7XG5cbi8vIHdpbmRvdy5vbnBvcHN0YXRlID0gZnVuY3Rpb24oZXYpIHtcbi8vICAgcG9wc3RhdGUub25OZXh0KGV2LnN0YXRlKTtcbi8vICAgaWYgKG9sZHBvcHN0YXRlKSB7XG4vLyAgICAgb2xkcG9wc3RhdGUoZXYpO1xuLy8gICB9XG4vLyB9O1xuXG4vLyBuYXZpZ2F0ZVxuLy8gLmZpbHRlcihmdW5jdGlvbihwYWdlKSB7XG4vLyAgIHJldHVybiAhd2luZG93Lmhpc3Rvcnkuc3RhdGUgfHwgd2luZG93Lmhpc3Rvcnkuc3RhdGUucGFnZSAhPT0gcGFnZTtcbi8vIH0pXG4vLyAuc3Vic2NyaWJlKGZ1bmN0aW9uKHBhZ2Upe1xuLy8gICB3aW5kb3cuaGlzdG9yeS5wdXNoU3RhdGUoe3BhZ2U6IHBhZ2V9LCAnRGlzY292ZXJ5JywgJycpO1xuLy8gfSk7XG5cbm1vZHVsZS5leHBvcnRzID0ge1xuICBuYXZpZ2F0ZTogbmF2aWdhdGUsXG4gIHBvcHN0YXRlOiBwb3BzdGF0ZVxufTtcbiJdfQ==